"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatBytes = void 0;
/// Source: https://stackoverflow.com/a/18650828
function formatBytes(bytes) {
    if (bytes === 0)
        return '0 Bytes';
    var k = 1024;
    var dm = 2;
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    return "".concat(parseFloat((bytes / Math.pow(k, i)).toFixed(dm)), " ").concat(sizes[i]);
}
exports.formatBytes = formatBytes;
